import {Component, Input, Output, EventEmitter, OnChanges, SimpleChanges} from '@angular/core';
import {EnvService} from "../services/env.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {AuthService} from "../services/auth.service";

@Component({
  selector: 'micro-contactGroup-picklist',
  templateUrl: './contactGroup-picklist.component.html'
})
export class ContactGroupPicklistComponent implements OnChanges  {
  all:any[];
  description:any;

  @Input()
  companyId: undefined;

  @Output()
  selectedItemsChange:EventEmitter<any> = new EventEmitter<any>();

  @Input()
  selectedItems:string[];

  @Input()
  listMinSize: number = 5;

  onNgModelChange(e) {
    this.selectedItemsChange.emit(e);
  }

  constructor(private auth:AuthService, private env:EnvService, private http:HttpClient) {
  }

  reload() {
    if (!this.companyId) {
      return;
    }

    let params:HttpParams = new HttpParams()
      .set('companyId', this.companyId);

    return this.http.get(`${this.env.e.url}/auth/contactGroups/all`, {params:params})
      .subscribe(data => {
        this.all = data as any[];
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    for (let prop in changes) {
      if (prop === 'companyId') {
        this.reload();
      }
    }
  }
}
